// Which Konnektive product id an order line uses (1.5.1).
//
// One answer for every path that picks it — lead, quick lead, main order,
// upsell voidMain replacement, coupon check:
//
//   one-time                       -> product.pid_konnektive
//   subscribe, subscription list   -> product.subscribeIds_konnektive[index]
//   subscribe, no list             -> product.pid_konnektive_ss  (1.5.0)
//
// The subscription list only exists on a translated konnektive-core config
// (see coreConfig.js), where the shopper picks a delivery frequency and the
// page writes its position into #cBillSubscribeIndex. A products[] config
// never has the list, so it resolves exactly as 1.5.0 did.
//
// Pure module: no DOM, no storage. Callers pass the index in.

export const SUBSCRIBE_ID_ERROR = 'This subscription option is not available right now. '
	+ 'Please choose a one-time purchase, or call us so we can help you place your order.';

export function hasSubscribeIds(product) {
	return Boolean(product)
		&& Array.isArray(product.subscribeIds_konnektive)
		&& product.subscribeIds_konnektive.length > 0;
}

// A missing, blank or non-numeric index means the page never offered a
// frequency picker: use the first frequency, as core's own hidden field
// defaulted to 0.
function subscribeIndexOf(value) {
	const index = parseInt(value, 10);
	return Number.isNaN(index) ? 0 : index;
}

export function resolveOrderProductId(product, purchaseType, subscribeIndex) {
	if (!product) {
		return undefined;
	}
	// Loose == on purpose: every caller compared this way in 1.5.0.
	// eslint-disable-next-line eqeqeq
	if (purchaseType == 'subscribe') {
		if (hasSubscribeIds(product)) {
			return product.subscribeIds_konnektive[subscribeIndexOf(subscribeIndex)];
		}
		return product.pid_konnektive_ss;
	}
	return product.pid_konnektive;
}

// True when a subscribe order would go out with no real product: the core
// config carries 0 as a placeholder (complexionmd, trycomplexionmd do not
// offer subscribe), or the index points past the list. Never true for a
// products[] config, so 1.5.0 behaviour is unchanged there.
export function isRefusedSubscribeId(product, purchaseType, productId) {
	// eslint-disable-next-line eqeqeq
	return purchaseType == 'subscribe' && hasSubscribeIds(product) && !productId;
}
